export default "/images/vendor/flag-icons/flags/1x1/fi.svg?aed885cc7a38b534b2b69bc5ca939979";